/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { extractParamsOfConcern, useNextRouter } from '@/data/Content/_NextRouter';
import {
	getCurrentUserFromStorage,
	getPreviewToken,
} from '@/data/forReactAndMobile/SaveCurrentUser';
import { constructClientPreviewTokenHeaderRequestParams } from '@/data/utils/constructRequestParams';
import { useMemo } from 'react';

/**
 * Build extra header parameter, in particular WCPreviewToken header.
 * @returns header parameters with PreviewToken
 */

export const useExtraRequestParameters = (insertTokens = true) => {
	const { asPath } = useNextRouter();
	const currentUserStorage = getCurrentUserFromStorage(
		process.env.NEXT_PUBLIC_REACT_APP_ROUTER_BASENAME || ''
	);
	const previewUserToken = getPreviewToken(process.env.NEXT_PUBLIC_REACT_APP_ROUTER_BASENAME || '');
	const {
		queryOfConcern: { WCPreviewToken: previewToken },
	} = extractParamsOfConcern(asPath);

	const previewTokenUser: string | undefined = previewUserToken?.WCPreviewToken ?? previewToken;

	const params = useMemo(
		() =>
			constructClientPreviewTokenHeaderRequestParams(
				previewTokenUser,
				currentUserStorage,
				insertTokens
			),
		[currentUserStorage, previewTokenUser, insertTokens]
	);
	return params;
};
